// ============================================================
// SHARED HOOKS
// ============================================================

import { useState, useMemo } from 'react';
import { ITEMS_PER_PAGE } from '../utils/constants';

export const usePagination = (data, itemsPerPage = ITEMS_PER_PAGE) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(data.length / itemsPerPage));
  const paginated = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return data.slice(start, start + itemsPerPage);
  }, [data, currentPage, itemsPerPage]);

  const goTo = (page) => setCurrentPage(Math.min(Math.max(1, page), totalPages));

  return { currentPage, totalPages, paginated, goTo, setCurrentPage };
};

export const useSearch = (data, keys) => {
  const [query, setQuery] = useState('');
  const filtered = useMemo(() => {
    if (!query.trim()) return data;
    const q = query.toLowerCase();
    return data.filter(item => keys.some(key => String(item[key] || '').toLowerCase().includes(q)));
  }, [data, query, keys]);
  return { query, setQuery, filtered };
};

export const useFilter = (data, key) => {
  const [filter, setFilter] = useState('');
  const filtered = useMemo(() => {
    if (!filter) return data;
    return data.filter(item => item[key] === filter);
  }, [data, filter, key]);
  return { filter, setFilter, filtered };
};
